var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lens") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CF",
    fillRule: "nonzero",
    stroke: "#B8C1CF",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5,
    d: "M13 12.057a.666.666 0 1 1-.943.943L8.933 9.876A5.281 5.281 0 0 1 5.667 11a5.293 5.293 0 0 1-3.771-1.563 5.296 5.296 0 0 1-1.563-3.77c0-1.425.556-2.764 1.563-3.771A5.294 5.294 0 0 1 5.666.333c1.425 0 2.765.555 3.771 1.563A5.297 5.297 0 0 1 11 5.666a5.285 5.285 0 0 1-1.124 3.267L13 12.057zm-7.333-2.39a3.973 3.973 0 0 0 2.828-1.172 3.972 3.972 0 0 0 1.172-2.828 3.971 3.971 0 0 0-1.172-2.828 3.97 3.97 0 0 0-2.828-1.172 3.97 3.97 0 0 0-2.828 1.172 3.972 3.972 0 0 0-1.172 2.828 3.972 3.972 0 0 0 1.172 2.828 3.973 3.973 0 0 0 2.828 1.172z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.6f6a52fa.svg";
export { ForwardRef as ReactComponent };